import { render, staticRenderFns } from "./uploadPicOne.vue?vue&type=template&id=5d807ab6&scoped=true&"
import script from "./uploadPicOne.vue?vue&type=script&lang=js&"
export * from "./uploadPicOne.vue?vue&type=script&lang=js&"
import style0 from "./uploadPicOne.vue?vue&type=style&index=0&id=5d807ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d807ab6",
  null
  
)

export default component.exports